import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { selectActiveLimits, selectLimitsLoaded } from '@/store/selectors/limitsSelectors';
import { envIsSweden } from '@/constants/constants';
import { LimitDuration } from '@lucky7ventures/bff-types';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useRequiredDepositLimitsCheck(): void {
  const limitsLoaded = useSelector(selectLimitsLoaded);
  const activeLimits = useSelector(selectActiveLimits);
  const { openModal } = useModal();

  useEffect(() => {
    if (!envIsSweden()) {
      return;
    }

    if (limitsLoaded) {
      // For the Sweden build we require the user to have Daily, Weekly and Monthly Deposit limit
      // 1 - daily, 2 - weekly, 3 - monthly
      const requiredLimitDurations = [
        LimitDuration._24Hours,
        LimitDuration._1Week,
        LimitDuration._1Month,
      ];
      const missingLimitDurations = requiredLimitDurations.filter(
        i => !activeLimits.find(limit => limit.duration === i),
      );
      if (missingLimitDurations.length > 0) {
        openModal(MODALS.REQUIRED_DEPOSIT_LIMITS);
      }
    }
  }, [limitsLoaded, activeLimits]);
}
